export const environment = {
  production: true,
  envName: "production",
  apiBaseUrl: "https://api.ticketaccesshub.com/api/v1",
  adminBaseUrl: "https://admin.ticketaccesshub.com",
  siteBaseUrl: "https://www.ticketaccesshub.com",
  chatServiceBaseUrl: "https://apichat.ticketaccesshub.com",
  fakeCheckoutEnabled: false,
  ga: {
    enabled: true,
    id: "G-KY3G6QH7XV",
  },
  sentry: {
    enabled: true,
    dsn: "https://0c4a169f19f50ba9536ff01a2af76feb@o4511667960610817.ingest.us.sentry.io/4511668029489152",
    release: "12106c2d30bad60e2222f8a48df1ea5ef5072244",
    tracesSampleRate: 0,
  },
};
